// extracted by mini-css-extract-plugin
module.exports = {"brandContainer":"logo_brandContainer__1JkHQ","brandName":"logo_brandName__MY7AF"};